export enum ETipoEnderecoDiferente {
  Retirada = 1,
  Entrega = 2,
}
